var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags_detail_tag_container"},[_c('ul',{staticClass:"tags_detail_unordered_list"},_vm._l((_vm.tagLabels),function(tagLabel){return _c('li',{key:tagLabel.label,staticClass:"tags_detail_tags_list"},[_c('b-badge',{staticClass:"tags_detail_tag",attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(tagLabel)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }